(function (f) { if (typeof exports === "object" && typeof module !== "undefined") { module.exports = f() } else if (typeof define === "function" && define.amd) { define([], f) } else { var g; if (typeof window !== "undefined") { g = window } else if (typeof global !== "undefined") { g = global } else if (typeof self !== "undefined") { g = self } else { g = this } g.appNavigation = f() } })(function () {
    var define, module, exports; return (function e(t, n, r) { function s(o, u) { if (!n[o]) { if (!t[o]) { var a = typeof require == "function" && require; if (!u && a) return a(o, !0); if (i) return i(o, !0); var f = new Error("Cannot find module '" + o + "'"); throw f.code = "MODULE_NOT_FOUND", f } var l = n[o] = { exports: {} }; t[o][0].call(l.exports, function (e) { var n = t[o][1][e]; return s(n ? n : e) }, l, l.exports, e, t, n, r) } return n[o].exports } var i = typeof require == "function" && require; for (var o = 0; o < r.length; o++) s(r[o]); return s })({
        1: [function (require, module, exports) {
            var css = ".nps-extranet-app-navigation {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.5;\n  color: #00427a;\n  background-color: transparent;\n}\n.nps-extranet-app-navigation .fade-visibility-add {\n  visibility: visible;\n  opacity: 1;\n}\n.nps-extranet-app-navigation .fade-visibility {\n  -webkit-transition-property: opacity, visibility;\n  transition-property: opacity, visibility;\n  -webkit-transition-duration: 0.2s;\n  transition-duration: 0.2s;\n  -webkit-transition-timing-function: ease-in-out;\n  transition-timing-function: ease-in-out;\n  visibility: hidden;\n  opacity: 0;\n}\n.nps-extranet-app-navigation > .catalog {\n  position: absolute;\n  display: block;\n  top: 55px;\n  left: 10px;\n  background-color: #ffffff;\n  border: 1px solid #c6c5c4;\n  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);\n  width: 305px;\n  padding: 15px;\n  text-align: center;\n  -webkit-transition-property: opacity, visibility;\n  transition-property: opacity, visibility;\n  -webkit-transition-duration: 0.2s;\n  transition-duration: 0.2s;\n  -webkit-transition-timing-function: ease-in-out;\n  transition-timing-function: ease-in-out;\n  visibility: hidden;\n  opacity: 0;\n}\n.nps-extranet-app-navigation > .catalog.active {\n  visibility: visible;\n  opacity: 1;\n}\n.nps-extranet-app-navigation > .catalog > .loading {\n  color: #00427a;\n}\n.nps-extranet-app-navigation > .catalog > .error {\n  color: #ae2233;\n}\n.nps-extranet-app-navigation > .catalog > .applications {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application {\n  display: inline-block;\n  vertical-align: top;\n  width: 90px;\n  height: 90px;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application:hover:not(.disabled):not(.current) .icon {\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2080%2060%22%3E%0D%0A%09%3Crect%20fill%3D%22%23002348%22%20width%3D%2280%22%20height%3D%2260%22%2F%3E%0D%0A%3C%2Fsvg%3E%0D%0A\");\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application:hover:not(.disabled):not(.current) .name {\n  color: #002348;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application.current {\n  background-color: #00427a;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application.current .icon {\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2080%2060%22%3E%0D%0A%09%3Crect%20fill%3D%22%23FFFFFF%22%20width%3D%2280%22%20height%3D%2260%22%2F%3E%0D%0A%3C%2Fsvg%3E%0D%0A\");\n  color: #00427a;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application.current .name {\n  color: white;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application.disabled .icon {\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2080%2060%22%3E%0D%0A%09%3Crect%20fill%3D%22%23C6C5C4%22%20width%3D%2280%22%20height%3D%2260%22%2F%3E%0D%0A%3C%2Fsvg%3E%0D%0A\");\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application.disabled .name {\n  color: #c6c5c4;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application .icon {\n  display: inline-block;\n  vertical-align: top;\n  margin-top: 5px;\n  width: 80px;\n  height: 60px;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2080%2060%22%3E%0D%0A%09%3Crect%20fill%3D%22%2300427A%22%20width%3D%2280%22%20height%3D%2260%22%2F%3E%0D%0A%3C%2Fsvg%3E%0D%0A\");\n  color: white;\n  font-size: 40px;\n}\n.nps-extranet-app-navigation > .catalog > .applications > .application .name {\n  display: inline-block;\n  vertical-align: top;\n  white-space: nowrap;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #00427a;\n  width: 80px;\n}\n.nps-extranet-app-navigation > .trigger {\n  position: relative;\n  width: 60px;\n  height: 60px;\n}\n.nps-extranet-app-navigation > .trigger.active > .icon {\n  background-color: #588dc0;\n}\n.nps-extranet-app-navigation > .trigger.active > .arrow {\n  visibility: visible;\n  opacity: 1;\n}\n.nps-extranet-app-navigation > .trigger > .icon {\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2040%2040%22%3E%0D%0A%09%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M15%2C15h-4v-4h4V15z%20M22%2C11h-4v4h4V11z%20M29%2C11h-4v4h4V11z%20M15%2C18h-4v4h4V18z%20M22%2C18h-4v4h4V18z%20M29%2C18h-4v4h4%0D%0A%09V18z%20M15%2C25h-4v4h4V25z%20M22%2C25h-4v4h4V25z%20M29%2C25h-4v4h4V25z%22%2F%3E%0D%0A%3C%2Fsvg%3E%0D%0A\");\n  position: relative;\n  width: 40px;\n  height: 40px;\n  top: 10px;\n  left: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.nps-extranet-app-navigation > .trigger > .icon:hover {\n  background-color: #588dc0;\n  opacity: 0.4;\n}\n.nps-extranet-app-navigation > .trigger > .arrow {\n  -webkit-transition-property: opacity, visibility;\n  transition-property: opacity, visibility;\n  -webkit-transition-duration: 0.2s;\n  transition-duration: 0.2s;\n  -webkit-transition-timing-function: ease-in-out;\n  transition-timing-function: ease-in-out;\n  visibility: hidden;\n  opacity: 0;\n}\n.nps-extranet-app-navigation > .trigger > .arrow.upper {\n  content: '';\n  display: block;\n  width: 0;\n  height: 0;\n  -moz-transform: scale(0.9999);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 7px solid #c6c5c4;\n  position: absolute;\n  z-index: 1;\n  left: 25px;\n  top: 48px;\n}\n.nps-extranet-app-navigation > .trigger > .arrow.lower {\n  content: '';\n  display: block;\n  width: 0;\n  height: 0;\n  -moz-transform: scale(0.9999);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 7px solid #ffffff;\n  position: absolute;\n  z-index: 2;\n  left: 25px;\n  top: 49px;\n}\n"; (require("browserify-css").createStyle(css)); module.exports = css;
        }, { "browserify-css": 3 }], 2: [function (require, module, exports) {
            addEventListener.removeEventListener = removeEventListener
            addEventListener.addEventListener = addEventListener

            module.exports = addEventListener

            var Events = null

            function addEventListener(el, eventName, listener, useCapture) {
                Events = Events || (
                  document.addEventListener ?
    { add: stdAttach, rm: stdDetach } :
    { add: oldIEAttach, rm: oldIEDetach }
                )

                return Events.add(el, eventName, listener, useCapture)
            }

            function removeEventListener(el, eventName, listener, useCapture) {
                Events = Events || (
                  document.addEventListener ?
    { add: stdAttach, rm: stdDetach } :
    { add: oldIEAttach, rm: oldIEDetach }
                )

                return Events.rm(el, eventName, listener, useCapture)
            }

            function stdAttach(el, eventName, listener, useCapture) {
                el.addEventListener(eventName, listener, useCapture)
            }

            function stdDetach(el, eventName, listener, useCapture) {
                el.removeEventListener(eventName, listener, useCapture)
            }

            function oldIEAttach(el, eventName, listener, useCapture) {
                if (useCapture) {
                    throw new Error('cannot useCapture in oldIE')
                }

                el.attachEvent('on' + eventName, listener)
            }

            function oldIEDetach(el, eventName, listener, useCapture) {
                el.detachEvent('on' + eventName, listener)
            }

        }, {}], 3: [function (require, module, exports) {
            'use strict';
            // For more information about browser field, check out the browser field at https://github.com/substack/browserify-handbook#browser-field.

            module.exports = {
                // Create a <link> tag with optional data attributes
                createLink: function (href, attributes) {
                    var head = document.head || document.getElementsByTagName('head')[0];
                    var link = document.createElement('link');

                    link.href = href;
                    link.rel = 'stylesheet';

                    for (var key in attributes) {
                        if (!attributes.hasOwnProperty(key)) {
                            continue;
                        }
                        var value = attributes[key];
                        link.setAttribute('data-' + key, value);
                    }

                    head.appendChild(link);
                },
                // Create a <style> tag with optional data attributes
                createStyle: function (cssText, attributes) {
                    var head = document.head || document.getElementsByTagName('head')[0],
                        style = document.createElement('style');

                    style.type = 'text/css';

                    for (var key in attributes) {
                        if (!attributes.hasOwnProperty(key)) {
                            continue;
                        }
                        var value = attributes[key];
                        style.setAttribute('data-' + key, value);
                    }

                    if (style.sheet) { // for jsdom and IE9+
                        style.innerHTML = cssText;
                        style.sheet.cssText = cssText;
                        head.appendChild(style);
                    } else if (style.styleSheet) { // for IE8 and below
                        head.appendChild(style);
                        style.styleSheet.cssText = cssText;
                    } else { // for Chrome, Firefox, and Safari
                        style.appendChild(document.createTextNode(cssText));
                        head.appendChild(style);
                    }
                }
            };

        }, {}], 4: [function (require, module, exports) {
            // contains, add, remove, toggle
            var indexof = require('indexof')

            module.exports = ClassList

            function ClassList(elem) {
                var cl = elem.classList

                if (cl) {
                    return cl
                }

                var classList = {
                    add: add
                    , remove: remove
                    , contains: contains
                    , toggle: toggle
                    , toString: $toString
                    , length: 0
                    , item: item
                }

                return classList

                function add(token) {
                    var list = getTokens()
                    if (indexof(list, token) > -1) {
                        return
                    }
                    list.push(token)
                    setTokens(list)
                }

                function remove(token) {
                    var list = getTokens()
                        , index = indexof(list, token)

                    if (index === -1) {
                        return
                    }

                    list.splice(index, 1)
                    setTokens(list)
                }

                function contains(token) {
                    return indexof(getTokens(), token) > -1
                }

                function toggle(token) {
                    if (contains(token)) {
                        remove(token)
                        return false
                    } else {
                        add(token)
                        return true
                    }
                }

                function $toString() {
                    return elem.className
                }

                function item(index) {
                    var tokens = getTokens()
                    return tokens[index] || null
                }

                function getTokens() {
                    var className = elem.className

                    return filter(className.split(" "), isTruthy)
                }

                function setTokens(list) {
                    var length = list.length

                    elem.className = list.join(" ")
                    classList.length = length

                    for (var i = 0; i < list.length; i++) {
                        classList[i] = list[i]
                    }

                    delete list[length]
                }
            }

            function filter(arr, fn) {
                var ret = []
                for (var i = 0; i < arr.length; i++) {
                    if (fn(arr[i])) ret.push(arr[i])
                }
                return ret
            }

            function isTruthy(value) {
                return !!value
            }

        }, { "indexof": 5 }], 5: [function (require, module, exports) {

            var indexOf = [].indexOf;

            module.exports = function (arr, obj) {
                if (indexOf) return arr.indexOf(obj);
                for (var i = 0; i < arr.length; ++i) {
                    if (arr[i] === obj) return i;
                }
                return -1;
            };
        }, {}], 6: [function (require, module, exports) {
            /*!
              Copyright (c) 2015 Jed Watson.
              Licensed under the MIT License (MIT), see
              http://jedwatson.github.io/classnames
            */
            /* global define */

            (function () {
                'use strict';

                var hasOwn = {}.hasOwnProperty;

                function classNames() {
                    var classes = '';

                    for (var i = 0; i < arguments.length; i++) {
                        var arg = arguments[i];
                        if (!arg) continue;

                        var argType = typeof arg;

                        if (argType === 'string' || argType === 'number') {
                            classes += ' ' + arg;
                        } else if (Array.isArray(arg)) {
                            classes += ' ' + classNames.apply(null, arg);
                        } else if (argType === 'object') {
                            for (var key in arg) {
                                if (hasOwn.call(arg, key) && arg[key]) {
                                    classes += ' ' + key;
                                }
                            }
                        }
                    }

                    return classes.substr(1);
                }

                if (typeof module !== 'undefined' && module.exports) {
                    module.exports = classNames;
                } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
                    // register as 'classnames', consistent with npm package name
                    define('classnames', function () {
                        return classNames;
                    });
                } else {
                    window.classNames = classNames;
                }
            }());

        }, {}], 7: [function (require, module, exports) {
            arguments[4][6][0].apply(exports, arguments)
        }, { "dup": 6 }], 8: [function (require, module, exports) {

        }, {}], 9: [function (require, module, exports) {
            var split = require('browser-split')
            var ClassList = require('class-list')
            require('html-element')

            function context() {

                var cleanupFuncs = []

                function h() {
                    var args = [].slice.call(arguments), e = null
                    function item(l) {
                        var r
                        function parseClass(string) {
                            // Our minimal parser doesn’t understand escaping CSS special
                            // characters like `#`. Don’t use them. More reading:
                            // https://mathiasbynens.be/notes/css-escapes .

                            var m = split(string, /([\.#]?[^\s#.]+)/)
                            if (/^\.|#/.test(m[1]))
                                e = document.createElement('div')
                            forEach(m, function (v) {
                                var s = v.substring(1, v.length)
                                if (!v) return
                                if (!e)
                                    e = document.createElement(v)
                                else if (v[0] === '.')
                                    ClassList(e).add(s)
                                else if (v[0] === '#')
                                    e.setAttribute('id', s)
                            })
                        }

                        if (l == null)
                            ;
                        else if ('string' === typeof l) {
                            if (!e)
                                parseClass(l)
                            else
                                e.appendChild(r = document.createTextNode(l))
                        }
                        else if ('number' === typeof l
                          || 'boolean' === typeof l
                          || l instanceof Date
                          || l instanceof RegExp) {
                            e.appendChild(r = document.createTextNode(l.toString()))
                        }
                            //there might be a better way to handle this...
                        else if (isArray(l))
                            forEach(l, item)
                        else if (isNode(l))
                            e.appendChild(r = l)
                        else if (l instanceof Text)
                            e.appendChild(r = l)
                        else if ('object' === typeof l) {
                            for (var k in l) {
                                if ('function' === typeof l[k]) {
                                    if (/^on\w+/.test(k)) {
                                        (function (k, l) { // capture k, l in the closure
                                            if (e.addEventListener) {
                                                e.addEventListener(k.substring(2), l[k], false)
                                                cleanupFuncs.push(function () {
                                                    e.removeEventListener(k.substring(2), l[k], false)
                                                })
                                            } else {
                                                e.attachEvent(k, l[k])
                                                cleanupFuncs.push(function () {
                                                    e.detachEvent(k, l[k])
                                                })
                                            }
                                        })(k, l)
                                    } else {
                                        // observable
                                        e[k] = l[k]()
                                        cleanupFuncs.push(l[k](function (v) {
                                            e[k] = v
                                        }))
                                    }
                                }
                                else if (k === 'style') {
                                    if ('string' === typeof l[k]) {
                                        e.style.cssText = l[k]
                                    } else {
                                        for (var s in l[k]) (function (s, v) {
                                            if ('function' === typeof v) {
                                                // observable
                                                e.style.setProperty(s, v())
                                                cleanupFuncs.push(v(function (val) {
                                                    e.style.setProperty(s, val)
                                                }))
                                            } else
                                                e.style.setProperty(s, l[k][s])
                                        })(s, l[k][s])
                                    }
                                } else if (k.substr(0, 5) === "data-") {
                                    e.setAttribute(k, l[k])
                                } else {
                                    e[k] = l[k]
                                }
                            }
                        } else if ('function' === typeof l) {
                            //assume it's an observable!
                            var v = l()
                            e.appendChild(r = isNode(v) ? v : document.createTextNode(v))

                            cleanupFuncs.push(l(function (v) {
                                if (isNode(v) && r.parentElement)
                                    r.parentElement.replaceChild(v, r), r = v
                                else
                                    r.textContent = v
                            }))
                        }

                        return r
                    }
                    while (args.length)
                        item(args.shift())

                    return e
                }

                h.cleanup = function () {
                    for (var i = 0; i < cleanupFuncs.length; i++) {
                        cleanupFuncs[i]()
                    }
                    cleanupFuncs.length = 0
                }

                return h
            }

            var h = module.exports = context()
            h.context = context

            function isNode(el) {
                return el && el.nodeName && el.nodeType
            }

            function isText(el) {
                return el && el.nodeName === '#text' && el.nodeType == 3
            }

            function forEach(arr, fn) {
                if (arr.forEach) return arr.forEach(fn)
                for (var i = 0; i < arr.length; i++) fn(arr[i], i)
            }

            function isArray(arr) {
                return Object.prototype.toString.call(arr) == '[object Array]'
            }

        }, { "browser-split": 10, "class-list": 4, "html-element": 8 }], 10: [function (require, module, exports) {
            /*!
             * Cross-Browser Split 1.1.1
             * Copyright 2007-2012 Steven Levithan <stevenlevithan.com>
             * Available under the MIT License
             * ECMAScript compliant, uniform cross-browser split method
             */

            /**
             * Splits a string into an array of strings using a regex or string separator. Matches of the
             * separator are not included in the result array. However, if `separator` is a regex that contains
             * capturing groups, backreferences are spliced into the result each time `separator` is matched.
             * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
             * cross-browser.
             * @param {String} str String to split.
             * @param {RegExp|String} separator Regex or string to use for separating the string.
             * @param {Number} [limit] Maximum number of items to include in the result array.
             * @returns {Array} Array of substrings.
             * @example
             *
             * // Basic use
             * split('a b c d', ' ');
             * // -> ['a', 'b', 'c', 'd']
             *
             * // With limit
             * split('a b c d', ' ', 2);
             * // -> ['a', 'b']
             *
             * // Backreferences in result array
             * split('..word1 word2..', /([a-z]+)(\d+)/i);
             * // -> ['..', 'word', '1', ' ', 'word', '2', '..']
             */
            module.exports = (function split(undef) {

                var nativeSplit = String.prototype.split,
                  compliantExecNpcg = /()??/.exec("")[1] === undef,
                  // NPCG: nonparticipating capturing group
                  self;

                self = function (str, separator, limit) {
                    // If `separator` is not a regex, use `nativeSplit`
                    if (Object.prototype.toString.call(separator) !== "[object RegExp]") {
                        return nativeSplit.call(str, separator, limit);
                    }
                    var output = [],
                      flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.extended ? "x" : "") + // Proposed for ES6
                      (separator.sticky ? "y" : ""),
                      // Firefox 3+
                      lastLastIndex = 0,
                      // Make `global` and avoid `lastIndex` issues by working with a copy
                      separator = new RegExp(separator.source, flags + "g"),
                      separator2, match, lastIndex, lastLength;
                    str += ""; // Type-convert
                    if (!compliantExecNpcg) {
                        // Doesn't need flags gy, but they don't hurt
                        separator2 = new RegExp("^" + separator.source + "$(?!\\s)", flags);
                    }
                    /* Values for `limit`, per the spec:
                     * If undefined: 4294967295 // Math.pow(2, 32) - 1
                     * If 0, Infinity, or NaN: 0
                     * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
                     * If negative number: 4294967296 - Math.floor(Math.abs(limit))
                     * If other: Type-convert, then use the above rules
                     */
                    limit = limit === undef ? -1 >>> 0 : // Math.pow(2, 32) - 1
                    limit >>> 0; // ToUint32(limit)
                    while (match = separator.exec(str)) {
                        // `separator.lastIndex` is not reliable cross-browser
                        lastIndex = match.index + match[0].length;
                        if (lastIndex > lastLastIndex) {
                            output.push(str.slice(lastLastIndex, match.index));
                            // Fix browsers whose `exec` methods don't consistently return `undefined` for
                            // nonparticipating capturing groups
                            if (!compliantExecNpcg && match.length > 1) {
                                match[0].replace(separator2, function () {
                                    for (var i = 1; i < arguments.length - 2; i++) {
                                        if (arguments[i] === undef) {
                                            match[i] = undef;
                                        }
                                    }
                                });
                            }
                            if (match.length > 1 && match.index < str.length) {
                                Array.prototype.push.apply(output, match.slice(1));
                            }
                            lastLength = match[0].length;
                            lastLastIndex = lastIndex;
                            if (output.length >= limit) {
                                break;
                            }
                        }
                        if (separator.lastIndex === match.index) {
                            separator.lastIndex++; // Avoid an infinite loop
                        }
                    }
                    if (lastLastIndex === str.length) {
                        if (lastLength || !separator.test("")) {
                            output.push("");
                        }
                    } else {
                        output.push(str.slice(lastLastIndex));
                    }
                    return output.length > limit ? output.slice(0, limit) : output;
                };

                return self;
            })();

        }, {}], 11: [function (require, module, exports) {
            'use strict';

            var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })(); /* eslint-disable no-unused-vars */

            /* eslint-enable no-unused-vars */

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _hyperscript = require('hyperscript');

            var _hyperscript2 = _interopRequireDefault(_hyperscript);

            var _classnames = require('classnames');

            var _classnames2 = _interopRequireDefault(_classnames);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var Application = (function () {
                function Application(appModel) {
                    _classCallCheck(this, Application);

                    this.appModel = appModel;
                }

                _createClass(Application, [{
                    key: 'view',
                    value: function view() {
                        var iconLetter = this.appModel.name.charAt(0);
                        var spanContent = (0, _hyperscript2.default)(
                          'span',
                          null,
                          (0, _hyperscript2.default)(
                            'span',
                            { className: 'icon' },
                            iconLetter
                          ),
                          (0, _hyperscript2.default)(
                            'span',
                            { className: 'name' },
                            this.appModel.name
                          )
                        );
                        var content = spanContent;

                        if (this.appModel.enabled) {
                            content = (0, _hyperscript2.default)(
                              'a',
                              {
                                  target: '_blank', className: 'link',
                                  href: this.appModel.url,
                                  title: this.appModel.description
                              },
                              spanContent
                            );
                        }
                        return (0, _hyperscript2.default)(
                          'li',
                          {
                              className: (0, _classnames2.default)({
                                  'application': true,
                                  'current': this.appModel.isCurrent,
                                  'disabled': !this.appModel.enabled
                              })
                          },
                          content
                        );
                    }
                }]);

                return Application;
            })();

            exports.default = Application;

        }, { "classnames": 7, "hyperscript": 9 }], 12: [function (require, module, exports) {
            'use strict';

            var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })(); /* eslint-disable no-unused-vars */

            /* eslint-enable no-unused-vars */

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _hyperscript = require('hyperscript');

            var _hyperscript2 = _interopRequireDefault(_hyperscript);

            var _application = require('./application.js');

            var _application2 = _interopRequireDefault(_application);

            var _classnames = require('classnames');

            var _classnames2 = _interopRequireDefault(_classnames);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var Catalog = (function () {
                function Catalog() {
                    _classCallCheck(this, Catalog);

                    this._applications = null;
                    this.active = false;
                    this.loading = false;
                    this.error = false;
                }

                _createClass(Catalog, [{
                    key: 'view',
                    value: function view() {
                        var content = undefined;
                        if (this.error) {
                            content = (0, _hyperscript2.default)(
                              'span',
                              { className: 'error' },
                              'Error fetching applications'
                            );
                        } else if (this.loading || !this._applications) {
                            content = (0, _hyperscript2.default)(
                              'span',
                              { className: 'loading' },
                              'Loading...'
                            );
                        } else {
                            content = (0, _hyperscript2.default)(
                              'ul',
                              { className: 'applications' },
                              this._applications.map(function (app) {
                                  return app.view();
                              })
                            );
                        }
                        return (0, _hyperscript2.default)(
                          'div',
                          { className: (0, _classnames2.default)({ 'catalog': true, 'active': this.active }) },
                          content
                        );
                    }
                }, {
                    key: 'applications',
                    set: function set(applications) {
                        this._applications = applications.map(function (appModel) {
                            return new _application2.default(appModel);
                        });
                    }
                }]);

                return Catalog;
            })();

            exports.default = Catalog;

        }, { "./application.js": 11, "classnames": 7, "hyperscript": 9 }], 13: [function (require, module, exports) {
            'use strict';

            var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })(); /* eslint-disable no-unused-vars */

            /* eslint-enable no-unused-vars */

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _hyperscript = require('hyperscript');

            var _hyperscript2 = _interopRequireDefault(_hyperscript);

            var _addEventListener = require('add-event-listener');

            var _addEventListener2 = _interopRequireDefault(_addEventListener);

            var _classList = require('class-list');

            var _classList2 = _interopRequireDefault(_classList);

            var _trigger = require('./trigger.js');

            var _trigger2 = _interopRequireDefault(_trigger);

            var _catalog = require('./catalog.js');

            var _catalog2 = _interopRequireDefault(_catalog);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var Navigator = (function () {
                function Navigator(env) {
                    var _this = this;

                    _classCallCheck(this, Navigator);

                    this.env = env;
                    this._active = false;
                    this.trigger = new _trigger2.default(function () {
                        return _this.triggerClicked();
                    });
                    this.catalog = new _catalog2.default();
                    this.container = document.querySelector('.nps-extranet-app-navigation');
                    this.render();
                }

                _createClass(Navigator, [{
                    key: 'loadApplications',
                    value: function loadApplications(token) {
                        var _this2 = this;

                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', this.env.applicationDiscoveryUri, true);
                        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState === 4) {
                                _this2.catalog.loading = false;
                                if (xhr.status === 200) {
                                    _this2.catalog.applications = JSON.parse(xhr.responseText).applications;
                                    _this2.renderCatalog();
                                } else {
                                    _this2.catalog.error = true;
                                    _this2.renderCatalog();
                                }
                            }
                        };
                        xhr.onerror = function () {
                            _this2.catalog.error = true;
                            _this2.renderCatalog();
                        };
                        this.catalog.loading = true;
                        this.renderCatalog();
                        xhr.send();
                    }
                }, {
                    key: 'renderCatalog',
                    value: function renderCatalog() {
                        var catalog = this.catalog.view();
                        this.container.replaceChild(catalog, this.catalogView);
                        this.catalogView = catalog;
                    }
                }, {
                    key: 'triggerClicked',
                    value: function triggerClicked() {
                        this.active = !this.active;
                    }
                }, {
                    key: 'render',
                    value: function render() {
                        if (this.triggerView) this.container.removeChild(this.triggerView);
                        if (this.catalogView) this.container.removeChild(this.catalogView);

                        this.triggerView = this.trigger.view();
                        this.catalogView = this.catalog.view();

                        this.container.appendChild(this.triggerView);
                        this.container.appendChild(this.catalogView);
                    }
                }, {
                    key: 'windowClicked',
                    value: function windowClicked(event) {
                        if (event.target === this.container || this.container.contains(event.target)) {
                            return;
                        }
                        this.active = false;
                    }
                }, {
                    key: 'active',
                    set: function set(active) {
                        var _this3 = this;

                        this._active = active;

                        var triggerClasses = (0, _classList2.default)(this.triggerView);
                        var catalogClasses = (0, _classList2.default)(this.catalogView);

                        this.catalog.active = active;
                        triggerClasses.toggle('active');
                        catalogClasses.toggle('active');

                        _addEventListener2.default.removeEventListener(window, 'click', this.windowClickedListener);
                        this.windowClickedListener = function (event) {
                            return _this3.windowClicked(event);
                        };
                        if (active) {
                            _addEventListener2.default.addEventListener(window, 'click', this.windowClickedListener);
                        }
                    },
                    get: function get() {
                        return this._active;
                    }
                }]);

                return Navigator;
            })();

            exports.default = Navigator;

        }, { "./catalog.js": 12, "./trigger.js": 14, "add-event-listener": 2, "class-list": 4, "hyperscript": 9 }], 14: [function (require, module, exports) {
            'use strict';

            var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })(); /* eslint-disable no-unused-vars */

            /* eslint-enable no-unused-vars */

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _hyperscript = require('hyperscript');

            var _hyperscript2 = _interopRequireDefault(_hyperscript);

            var _classNames = require('classNames');

            var _classNames2 = _interopRequireDefault(_classNames);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var Trigger = (function () {
                function Trigger(clicked) {
                    _classCallCheck(this, Trigger);

                    this.clicked = clicked;
                }

                _createClass(Trigger, [{
                    key: 'view',
                    value: function view() {
                        return (0, _hyperscript2.default)(
                          'div',
                          { className: 'trigger' },
                          (0, _hyperscript2.default)('div', {
                              className: 'icon',
                              onclick: this.clicked
                          }),
                          (0, _hyperscript2.default)('div', {
                              className: (0, _classNames2.default)({
                                  'arrow': true,
                                  'lower': true
                              })
                          }),
                          (0, _hyperscript2.default)('div', {
                              className: (0, _classNames2.default)({
                                  'arrow': true,
                                  'upper': true
                              })
                          })
                        );
                    }
                }]);

                return Trigger;
            })();

            exports.default = Trigger;

        }, { "classNames": 6, "hyperscript": 9 }], 15: [function (require, module, exports) {
            'use strict';

            var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var Env = (function () {
                function Env(config) {
                    _classCallCheck(this, Env);

                    this.ssoServerOrigin = config.ssoServerOrigin || 'https://sso.nordpoolspot.com';
                    this.appsServerOrigin = config.appsServerOrigin || 'https://apps.nordpoolspot.com';
                }

                _createClass(Env, [{
                    key: 'applicationDiscoveryUri',
                    get: function get() {
                        return this.appsServerOrigin + '/api/applicationcatalog';
                    }
                }, {
                    key: 'ssoLogoutUri',
                    get: function get() {
                        return this.ssoServerOrigin + '/singlelogout';
                    }
                }]);

                return Env;
            })();

            exports.default = Env;

        }, {}], 16: [function (require, module, exports) {
            'use strict';

            var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _addEventListener = require('add-event-listener');

            var _addEventListener2 = _interopRequireDefault(_addEventListener);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var LogoutListener = (function () {
                function LogoutListener(env) {
                    _classCallCheck(this, LogoutListener);

                    this.env = env;
                }

                _createClass(LogoutListener, [{
                    key: 'createFrame',
                    value: function createFrame() {
                        var iframe = document.createElement('iframe');
                        iframe.setAttribute('src', this.env.ssoLogoutUri);
                        iframe.style.width = 0 + 'px';
                        iframe.style.height = 0 + 'px';
                        iframe.style.visibility = 'hidden';
                        document.body.appendChild(iframe);
                    }
                }, {
                    key: 'logoutHandler',
                    value: function logoutHandler(event, onLogout) {
                        if (event.data === 'Logout' && event.origin === this.env.ssoServerOrigin) {
                            onLogout();
                        }
                    }
                }, {
                    key: 'attach',
                    value: function attach(onLogout) {
                        var _this = this;

                        this.createFrame();
                        _addEventListener2.default.addEventListener(window, 'message', function (event) {
                            return _this.logoutHandler(event, onLogout);
                        });
                    }
                }]);

                return LogoutListener;
            })();

            exports.default = LogoutListener;

        }, { "add-event-listener": 2 }], 17: [function (require, module, exports) {
            'use strict';

            var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _logoutListener = require('./logoutListener.js');

            var _logoutListener2 = _interopRequireDefault(_logoutListener);

            var _navigator = require('./applicationCatalog/navigator.js');

            var _navigator2 = _interopRequireDefault(_navigator);

            require('../dist/appNavigation.css');

            var _env = require('./env.js');

            var _env2 = _interopRequireDefault(_env);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            var AppNavigation = (function () {
                function AppNavigation(config) {
                    _classCallCheck(this, AppNavigation);

                    var env = new _env2.default(config);
                    this.navigator = new _navigator2.default(env);
                    this.logoutListener = new _logoutListener2.default(env);
                }

                _createClass(AppNavigation, [{
                    key: 'loadApplications',
                    value: function loadApplications(token) {
                        this.navigator.loadApplications(token);
                    }
                }, {
                    key: 'attachLogoutListener',
                    value: function attachLogoutListener(onLogout) {
                        this.logoutListener.attach(onLogout);
                    }
                }]);

                return AppNavigation;
            })();

            exports.default = AppNavigation;
            window.AppNavigation = AppNavigation;

        }, { "../dist/appNavigation.css": 1, "./applicationCatalog/navigator.js": 13, "./env.js": 15, "./logoutListener.js": 16 }]
    }, {}, [17])(17)
});


//////////////////
// WEBPACK FOOTER
// ./~/@nordpoolgroup/nps-angular-2-common/src/Extranet/appNavigation.js
// module id = 723
// module chunks = 0